// table cellwidth
export const cellWidth = (minWidth: number) => ({
  style: {
    width: `${minWidth}px`,
    minWidth: `${minWidth}px`,
    // whiteSpace: "nowrap",
  },
});

export const cellMinWidth = (minWidth: number) => ({
  style: {
    minWidth: `${minWidth}px`,
    whiteSpace: "nowrap",
  },
});
